import React from 'react';
import {Container} from 'flux/utils';

import HttpService from 'service/HttpService';

import DesignerStore from 'stores/DesignerStore';
import SessionStore from 'stores/SessionStore';
import MessageStore from 'stores/MessageStore';
import Header from 'views/Header';

import AlertMessageBox from 'views/AlertMessageBox';
import AppConstants from '../AppConstants';

class HeaderContainer extends React.Component {
	static getStores() {
		return [SessionStore, MessageStore, DesignerStore];
	}

	static calculateState(prevState) {
		let newState = {
				session: SessionStore.getCurrentSession(),
				alertMessage: MessageStore.getAlertMessage(),

				stores: DesignerStore.getPopularStores(),
				influencers: DesignerStore.getPopularInfluencers(),
			};
		return newState;
	}

	componentDidMount() {
		if(!this.state.stores)
			HttpService.getPopularStores();

	}

	render() {
		const currentSession = this.state.session;
		const alertMessage = this.state.alertMessage;

		let forceOpenLogin = (alertMessage && alertMessage.message === AppConstants.LOGIN_TO_CONTINUE_MSG)? {selectedForm: AppConstants.SIGN_UP_FORMS.SOCIAL_LOGIN}: null;
		const alertAction = (alertMessage && alertMessage.alertAction)? alertMessage.alertAction: null;
		const actionData = (alertMessage && alertMessage.actionData)? alertMessage.actionData: null;

		if(alertAction) {
			const availableForms = Object.values(AppConstants.SIGN_UP_FORMS);
			
			if(availableForms.indexOf(alertAction) >= 0)
				forceOpenLogin = {selectedForm: alertAction, formData: actionData};
		}
		
		const stores = this.state.stores;
		const influencers = this.state.influencers;

		return <div>
				<Header session={currentSession} forceOpenLogin={forceOpenLogin}
					influencers={influencers} popularStores={stores} 
					turnOffSticky={this.props.turnOffSticky} />

				<AlertMessageBox message={alertMessage} />
			</div>;
	}
}


export default Container.create(HeaderContainer);


// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js